import { useState } from "react";
import { MdInfoOutline, MdArrowRight } from "react-icons/md";
import { CgArrowsScrollV } from "react-icons/cg";
import Lodinging from "../components_root/loading.jsx";
import Loadingimg from "../components_root/loadingimg.jsx";

const TechnicalDetails = ({ isLoading3, technicaldata }) => {
  const [openDetails, setOpenDetails] = useState({}); // Track which details are open

  const toggleDetails = (key) => {
    setOpenDetails((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="b-top">
      {isLoading3 ? (
        <Lodinging />
      ) : technicaldata.length === 0 ? (
        <div>No additional found</div>
      ) : (
        technicaldata.map((product, pIndex) => {
          // 🔹 Group fields by details value
          const grouped = {};
          product.child.forEach((field) => {
            const groupKey = field.details || "Other";
            if (!grouped[groupKey]) grouped[groupKey] = [];
            grouped[groupKey].push(field);
          });

          return (
            <div key={pIndex} className="b-section">
              {Object.entries(grouped).map(([detailsValue, fields], gIndex) => {
                const groupKey = `${pIndex}-group-${gIndex}`;
                const isOpen = openDetails[groupKey] ?? false; // ❌ hidden by default

                return (
                  <div key={groupKey} className="b-top">
                    {/* 🔹 DETAILS HEADER */}
                    <div
                      className="p-1 items-back-fill pointer"
                      onClick={() => toggleDetails(groupKey)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <MdInfoOutline className="icon" />
                        <div className="text-h2 bold fcap m-1">
                          {detailsValue}
                        </div>
                      </div>
                      <CgArrowsScrollV
                        className={`icon transition-transform duration-200 ${
                          isOpen ? "rotate-180" : "rotate-0"
                        }`}
                      />
                    </div>

                    {/* 🔹 SHOW / HIDE FIELDS */}
                    {isOpen && (
                      <div className="b-top p-1">
                        {fields.map((field, fIndex) => (
                          <div
                            key={`${groupKey}-field-${fIndex}`}
                            className="p-1"
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td width={22}>
                                    <MdArrowRight className="icon" />
                                  </td>
                                  <td width={210}>
                                    <div className="text-h2 fcap">
                                      {field.fieldName.replaceAll("_", " ")}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-h2">
                                      {field.fieldValue}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })
      )}
    </div>
  );
};

export default TechnicalDetails;
